import { render, staticRenderFns } from "./SupplierDetails.vue?vue&type=template&id=761423ba"
import script from "./SupplierDetails.vue?vue&type=script&lang=js"
export * from "./SupplierDetails.vue?vue&type=script&lang=js"
import style0 from "./SupplierDetails.vue?vue&type=style&index=0&id=761423ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports